import { render, staticRenderFns } from "./OrderExchange.vue?vue&type=template&id=af9d1628&scoped=true&"
import script from "./OrderExchange.vue?vue&type=script&lang=js&"
export * from "./OrderExchange.vue?vue&type=script&lang=js&"
import style0 from "./OrderExchange.vue?vue&type=style&index=0&id=af9d1628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9d1628",
  null
  
)

export default component.exports